import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, AfterContentInit, Input, EventEmitter, Output } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertType } from 'base-models';
import { MessageError } from 'base-models';
import { SortHelper } from 'shtools';
import { OlMainComponent } from 'gmap';
import { Flight, IssueImage, Site } from 'solar-bo';
import { FrLayer, FrCoordinate } from 'gmap';
import { mapcte } from 'gmap';

import { OlObjectTypeEnum } from 'solar-bo';;
import { IssueImageComponent } from '../../supervis/issueimage/issueimage.component';
import { MapOnMoveHelper } from 'gmap';
import { MapTooltipHelper } from 'gmap';
import { DashboardService } from '../../services/dashboard.service';
import { SolarBase1Component } from '@solar/solar/solar-base';
import { IDB_filter, IDB_Chart_Res, DB_filter, DBColumnsEnum } from 'solar-bo';
import { ErrorcontrolService } from 'basecomponents';

import { MapMarkerHelper } from 'gmap';
import { MapSupervisionHelper, MapIssueOverlay, MapSiteHelper, MapSupervisionIssues } from '@solar/ol';
import { DbFilter } from '@solar/solar/dashboard/db-overview/db-filter-helper';
import { MapFlightOverlay } from '@solar/ol/map-flight-overlay';
import ImageLayer from 'ol/layer/Image';
import Static from 'ol/source/ImageStatic';



//providers:[DashboardService]
@Component({
  selector: 'app-flight-list-map',
  templateUrl: './flight-list-map.component.html',
  styleUrls: ['./flight-list-map.component.scss']
})
export class FlightListMapComponent extends SolarBase1Component implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {


  @ViewChild('map_db') mapc: OlMainComponent;
  @Input() autoLoad: boolean = true;
  @Input() site;
  private _supervision;
  @Input()
  public get supervision() {
    return this._supervision;
  }
  public set supervision(value) {
    this._supervision = value;
    this.site = this._supervision.site;
  }
  @Output() flightClickedEvent: EventEmitter<Flight> = new EventEmitter();

  tooltipOverlay: MapFlightOverlay;
  public dbFilter: DbFilter = new DbFilter();
  /**
   * layer object with issues
   */
  layer_Issues: any[] = [];
  mapSupervisionIssues: MapSupervisionIssues;
  mapSiteHelper: MapSiteHelper;

  constructor(
    private dashService: DashboardService
  ) {
    super();
    this.mapSiteHelper = new MapSiteHelper();
  }

  ngOnInit() {

  }

  mapcontrol: boolean = true;

  mapOnMoveHelper: MapOnMoveHelper;
  ngAfterViewInit() {
    console.log("FlightListMapComponent ngAfterViewInit");
    if (this.mapc) {
      this.mapcontrol = true;
      this.mapc.onFeatureClick.subscribe(res => this.onFeatureClick(res));
      this.mapOnMoveHelper = new MapOnMoveHelper(this.mapc);
      this.tooltipOverlay = new MapFlightOverlay(this.mapc);
      this.mapOnMoveHelper.addListener(this.tooltipOverlay);
      console.log("FlightListMapComponent ngAfterViewInit mapc configured");
    }
  }

  ngAfterContentInit() {

  }

  ngOnDestroy() {
    this.mapcontrol = false;
  }

  onFeatureClick(features: any[]) {
    console.log(features);
    if (!features) {
      return;
    }
    for (let featInfo of features) {
      let feat = featInfo.feature;
      let layerInfo: FrLayer = feat.frlayerinfo;
      if (layerInfo) {
        if (layerInfo.ref == OlObjectTypeEnum.flightimageproj) {
          let item = layerInfo.refObject;
          if (item) {
            console.log("Feature clicked is flightimageproj:", item);
            this.flightClickedEvent.emit(item);
            this.drawprojectedimage(feat);
            //return;
          }
        }
      }
    }
  }


  addLayerForToolTip(layerid: any) {
    this.tooltipOverlay.addLayer(layerid);
  }
  /**
   * Draw projected image
   * @param feat 
   */
  drawprojectedimage(feat) {
    let map = this.mapc.map;
    let layerInfo: FrLayer = feat.frlayerinfo;
    let item: IssueImage = layerInfo.refObject;

    let layerinfo: FrLayer = new FrLayer("Image: " + item.name, item.id_flight + "_" + item.name);
    let layer = this.mapc.layerGetByFrid(layerinfo.id);
    if (layer) {
      this.mapc.layerShowHide(layerinfo.id);
      return;
    }
    let imgURL = MapSupervisionHelper.issueUrlImgByFullFields(item.name, this.site.id, this.supervision.id, item.id_flight);
    const geometry = feat.getGeometry();
    const extent = geometry.getExtent();
    let imageLayer = new ImageLayer({
      source: new Static({
        url: imgURL,
        projection: map.getView().getProjection(),
        imageExtent: extent
      })
    });

    imageLayer[mapcte.frlayerinfo_FieldName] = layerinfo;
    this.mapc.layerAdd(imageLayer);
    console.log(this.mapc.map.getLayers());
    let zindex = imageLayer.getZIndex();
    let rasterLayer = this.mapc.layerGetByFrid(mapcte.RASTERPANELS);
    rasterLayer.setZIndex(99);
  }



}
